module.exports = __webpack_public_path__ + "static/media/354512cd0c9ad17f1cc406149227eb7.69b558c5.jpg";